import { useState, useEffect } from 'react';
import api from '@/lib/api';

export default function AnnouncementBar() {
    const [text, setText] = useState('');
    const [active, setActive] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        api.get('/announcement').then(({ data }) => {
            if (data.active && data.text) { setText(data.text); setActive(true); }
        }).catch(() => {});
    }, []);

    if (!active || dismissed) return null;

    return (
        <div className="bg-pink-600 text-white relative overflow-hidden" data-testid="announcement-bar">
            <div className="max-w-7xl mx-auto px-8 py-2 flex items-center justify-center">
                <div className="overflow-hidden whitespace-nowrap">
                    <p className="inline-block animate-marquee font-body text-xs sm:text-sm font-medium">
                        {text}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{text}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{text}
                    </p>
                </div>
            </div>
            <button onClick={() => setDismissed(true)} className="absolute right-2 top-1/2 -translate-y-1/2 text-white/70 hover:text-white text-lg leading-none px-1" data-testid="dismiss-announcement">&times;</button>
        </div>
    );
}
